
import { func_validation, getTotalCountFromHeader } from "functions";

export function tableData(props) {
    const {
        userGroupList,
        userList,
        userGroupListHeaders,
        userGroupPermissionList_validated,
    } = props;

    let userGroupList_formatted = [];
    if (func_validation.isArrayNotEmpty(userGroupList)) {
        userGroupList_formatted = func_validation.cloneArrayOfObject(userGroupList);
        userGroupList_formatted.map((userGroupDetail, userIndex) => {
            // Create list of user names
            let obj = {};
            let userGroupMappings = func_validation.getObjectPropertyValue(userGroupDetail, "UserGroupMappings");        
            if (func_validation.isArrayNotEmpty(userGroupMappings)) {
                userGroupList_formatted[userIndex]["UserGroupMappings"] = [];
                userGroupMappings.map((userGroupMappingObj) => {
                    let username_userGroupList = func_validation.getObjectPropertyValue(userGroupMappingObj, "UserName");

                    // Get the username from list
                    if (func_validation.isArrayNotEmpty(userList)) {
                        for (let i = 0; i < userList.length; i++) {
                            let userObj = userList[i];
                            let userName_userList = func_validation.getObjectPropertyValue(userObj, "UserName");

                            if (func_validation.isStringEqual_caseSensitive(userName_userList, username_userGroupList)) {
                                let obj = {};
                                obj["selectedIndex"] = i;
                                obj["username"] = userName_userList;

                                userGroupList_formatted[userIndex]["UserGroupMappings"].push(obj);
                                break;
                            }
                        }
                    }
                });

                let userGroups = func_validation.cloneArrayOfObject(userGroupList_formatted[userIndex]["UserGroupMappings"]);
                if (func_validation.isArrayNotEmpty(userGroups)) {
                    obj["UserGroupMappings"] = userGroups;
                }    
            }
            
            // Create list of user group permissions
            let groupPermissions = func_validation.getObjectPropertyValue(userGroupDetail, "GroupPermissions");
            if (func_validation.isArrayNotEmpty(groupPermissions)) {
                userGroupList_formatted[userIndex]["UserGroupPermissions"] = [];
                let userGroupPermissionList_formatted = userGroupList_formatted[userIndex]["UserGroupPermissions"];
                let userGroupPermissionIdListObj = {};
                groupPermissions.map((userGroupPermissionobj) => {
                    let permissionName = func_validation.getObjectPropertyValue(userGroupPermissionobj, "PermissionName");
                    let userGroupId = func_validation.getObjectPropertyValue(userGroupPermissionobj, "UserGroupId");

                    let userGroupPermissionName = "";
                    let permissions = permissionName.split("_");
                    if (func_validation.isStringTrimNotEmpty(permissionName) &&
                        permissions.length == 3) 
                        userGroupPermissionName = permissions[1];

                    // Get the user group permission from list
                    let userGroupPermissionObj = {};
                    if (func_validation.isArrayNotEmpty(userGroupPermissionList_validated) &&
                        func_validation.isNumberValid(userGroupId)) {
                        for (let i = 0; i < userGroupPermissionList_validated.length; i++) {
                            let permissionObj = userGroupPermissionList_validated[i];
                            let userGroupPermissionName_list = func_validation.getObjectPropertyValue(permissionObj, "UserGroupPermission");

                            if (func_validation.isStringEqual_caseSensitive(userGroupPermissionName_list, userGroupPermissionName)) {
                                let obj = {};
                                obj["selectedIndex"] = i;
                                obj["UserGroupPermission"] = userGroupPermissionName;
                                obj["UserGroupId"] = userGroupId;
                                userGroupPermissionObj = obj;

                                // Check for duplicates
                                if (!userGroupPermissionIdListObj[userGroupPermissionName]) {
                                    userGroupPermissionIdListObj[userGroupPermissionName] = true;
                                    userGroupPermissionList_formatted.push(userGroupPermissionObj);
                                }
                                break;
                            }
                        }
                    }
                });

                let userGroupPermissions = func_validation.cloneArrayOfObject(userGroupList_formatted[userIndex]["UserGroupPermissions"]);
                if (func_validation.isArrayNotEmpty(userGroupPermissions)) {
                    obj["UserGroupPermissions"] = userGroupPermissions;
                }
            }

            if (func_validation.isObjectNotEmpty(obj)) {
                userGroupList_formatted[userIndex]["subRows"] = [];
                userGroupList_formatted[userIndex]["subRows"].push(obj);
            }

        })
    }

    let userLabels = [];
    if (func_validation.isArrayNotEmpty(userList)) {
        userList.map((userObj, idx) => {
            let username = func_validation.getObjectPropertyValue(userObj, "UserName");
            userLabels.push(username);
        })
    }

    return {
        userGroupList_formatted,
        userGroupPermissionList_validated,
        userLabels,
        totalRecords: getTotalCountFromHeader(userGroupListHeaders)
    }
}